const initialState = {
    timespan: ["2025-06-01T00:00:00.000Z","2025-06-30T00:00:00.000Z"],        // Timespan for timespan section
    resolved_timespan: ["2025-06-01T00:00:00.000Z","2025-06-30T00:00:00.000Z"],        // Resolved timespan for resolved date picker
    timespanType: "All", // Type of ticket to show in timespan section
    timespanAssignedTo: 0, // Tech assigned to selector in timespan section (starts with default id 0, which tells backend to ignore that filter)
    timespanAssignedToArray: [],    // This is the updated version of timespanAssignedTo when we switched over to multi-select

    report_timespan_change_detected: false,
    report_resolved_timespan_change_detected: false,
    report_timespan_type_change_detected: false,
    report_assigned_to_change_detected: false,

    timespan_ticket_report_open: false,
    overdue_ticket_report_open: false,
    hot_ticket_report_open: false,
    resolved_ticket_report_open: false,
    resolved_by_tech_report_open: false,
    survey_report_open: false,

    timespan_sort_by: "id",
    overdue_sort_by: "id",
    hot_sort_by: "id",
    resolved_sort_by: "id",
    resolved_by_tech_sort_by: "name",
    survey_sort_by: "id",
    survey_average_sort_by: "assigned_tech_name",

    timespan_sort_order: "ASC",
    overdue_sort_order: "ASC",
    hot_sort_order: "ASC",
    resolved_sort_order: "ASC",
    resolved_by_tech_sort_order: "ASC",
    survey_sort_order: "ASC",
    survey_average_sort_order: "ASC"
};

function reportsReducer(state = initialState, action) {
    switch (action.type) {
        case "UPDATE_TIMESPAN":
            if (action.payload) {
                return {
                    ...state,
                    timespan: action.payload
                };
            }
            break;
        case "UPDATE_RESOLVED_TIMESPAN":
            if (action.payload) {
                return {
                    ...state,
                    resolved_timespan: action.payload
                }
            }
            break;
        case "UPDATE_TIMESPAN_TYPE":
            if (action.payload) {
                return {
                    ...state,
                    timespanType: action.payload
                };
            }
            break;
        case "UPDATE_TIMESPAN_ASSIGNEDTO":
            if (action.payload !== null) {
                return {
                    ...state,
                    timespanAssignedTo: action.payload
                };
            }
            break;
        case "UPDATE_TIMESPAN_ASSIGNED_TO_ARRAY":
            if (action.payload !== null) {
                return {
                    ...state,
                    timespanAssignedToArray: action.payload
                };
            }
            break;
        case "UPDATE_TIMESPAN_SORTING":
            if (action.payload !== null) {
                return {
                    ...state,
                    timespan_sort_by: action.payload.sortBy,
                    timespan_sort_order: state.timespan_sort_order === "ASC" ? "DESC" : "ASC"
                };
            }
            break;
        case "UPDATE_OVERDUE_SORTING":
            if (action.payload !== null) {
                return {
                    ...state,
                    overdue_sort_by: action.payload.sortBy,
                    overdue_sort_order: state.overdue_sort_order === "ASC" ? "DESC" : "ASC"
                };
            }
            break;
        case "UPDATE_HOT_SORTING":
            if (action.payload !== null) {
                return {
                    ...state,
                    hot_sort_by: action.payload.sortBy,
                    hot_sort_order: state.hot_sort_order === "ASC" ? "DESC" : "ASC"
                };
            }
            break;
        case "UPDATE_RESOLVED_SORTING":
            if (action.payload !== null) {
                return {
                    ...state,
                    resolved_sort_by: action.payload.sortBy,
                    resolved_sort_order: state.resolved_sort_order === "ASC" ? "DESC" : "ASC"
                };
            }
            break;
        case "UPDATE_RESOLVED_BY_TECH_SORTING":
            if (action.payload !== null) {
                return {
                    ...state,
                    resolved_by_tech_sort_by: action.payload.sortBy,
                    resolved_by_tech_sort_order: state.resolved_by_tech_sort_order === "ASC" ? "DESC" : "ASC"
                };
            }
            break;
        case "UPDATE_SURVEY_SORTING":
            if (action.payload !== null) {
                return {
                    ...state,
                    survey_sort_by: action.payload.sortBy,
                    survey_sort_order: state.survey_sort_order === "ASC" ? "DESC" : "ASC"
                }
            }
            break;
        case "UPDATE_SURVEY_AVERAGE_SORTING":
            if (action.payload !== null) {
                return {
                    ...state,
                    survey_average_sort_by: action.payload.sortBy,
                    survey_average_sort_order: state.survey_average_sort_order === "ASC" ? "DESC" : "ASC"
                }
            }
            break;
        case "ALERT_REPORT_TIMESPAN_CHANGE_DETECTED":
            return {
                ...state,
                report_timespan_change_detected: true
            }
        case "REPORT_TIIMESPAN_CHANGE_RESOLVED":
            return {
                ...state,
                report_timespan_change_detected: false
            }
        case "ALERT_REPORT_RESOLVED_TIMESPAN_CHANGE_DETECTED":
            return {
                ...state,
                report_resolved_timespan_change_detected: true
            }
        case "REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED":
            return {
                ...state,
                report_resolved_timespan_change_detected: false
            }
        case "ALERT_REPORT_TIMESPAN_TYPE_CHANGE_DETECTED":
            return {
                ...state,
                report_timespan_type_change_detected: true
            }
        case "REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED":
            return {
                ...state,
                report_timespan_type_change_detected: false
            }
        case "ALERT_REPORT_ASSIGNED_TO_CHANGE_DETECTED":
            return {
                ...state,
                report_assigned_to_change_detected: true
            }
        case "REPORT_ASSIGNED_TO_CHANGE_RESOLVED":
            return {
                ...state,
                report_assigned_to_change_detected: false
            }
        case "UPDATE_TIMESPAN_TICKET_REPORT_OPEN_STATUS":
            return {
                ...state,
                timespan_ticket_report_open: !state.timespan_ticket_report_open
            }

        case "UPDATE_OVERDUE_TICKET_REPORT_OPEN_STATUS":
            return {
                ...state,
                overdue_ticket_report_open: !state.overdue_ticket_report_open
            }

        case "UPDATE_HOT_TICKET_REPORT_OPEN_STATUS":
            return {
                ...state,
                hot_ticket_report_open: !state.hot_ticket_report_open
            }

        case "UPDATE_RESOLVED_TICKET_REPORT_OPEN_STATUS":
            return {
                ...state,
                resolved_ticket_report_open: !state.resolved_ticket_report_open
            }

        case "UPDATE_RESOLVED_BY_TECH_REPORT_OPEN_STATUS":
            return {
                ...state,
                resolved_by_tech_report_open: !state.resolved_by_tech_report_open
            }
        
        case "UPDATE_SURVEY_REPORT_OPEN_STATUS":
            return {
                ...state,
                survey_report_open: !state.survey_report_open
            }

        default:
            return state;


    }
}

export default reportsReducer;
